export const TYPES = {
  GET_STRIPE_ACCOUNT_SUCCESS: "stripe/GET_STRIPE_ACCOUNT_SUCCESS",
};
